import { Theme } from '@mirai/ui';

export const getStyle = () => {
  const theme = Theme.get();

  const { accent, base, borderRadius, content, contentLight, error, font, fontSizeAction, fontSizeParagraph } = theme;

  return {
    Font_Family: font,
    Font_Size_Label: `${fontSizeParagraph}px`,
    Font_Size_Input_Fields: `${fontSizeParagraph}px`,
    Font_Size_Payment_Button: `${fontSizeAction}px`,
    Color_Container: base,
    Color_Border_Payment_Button: base,
    Radius_Border: `${borderRadius}px`,
    Color_Disabled: contentLight,
    Color_Error: error,
    Color_Primary: accent,
    Color_Input_Fields: base,
    Text_Color_For_Label: content,
    Text_Color_For_Payment_Button: base,
    Text_Color_For_Input_Fields: content,
    Color_For_Text_Placeholder: contentLight,
    Width_of_Container: '100%',
  };
};
